module.exports = __webpack_public_path__ + "static/media/bobWessels.51d4c157.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/bobWessels.jpg
// module id = 1563
// module chunks = 1